import { ReactNode } from 'react';
import styled from 'styled-components';

export interface ModalHeaderProps {
  image: string;
  imageAlt: string;
  title: string | ReactNode;
  subtitle?: string;
  className?: string;
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: ${({ theme }) => theme.spacing.M16};
  border-bottom: ${({ theme }) => `1px solid ${theme.colors.GREY_LIGHT}`};
`;

const Img = styled.img`
  width: 200px;
  height: 40px;
  margin-bottom: ${({ theme }) => theme.spacing.M16};
`;

const Title = styled.p`
  ${({ theme }) => theme.fontSize.L18};
  font-weight: ${({ theme }) => theme.fontWeight.bold};
  color: ${({ theme }) => theme.colors.GREY_DARKER};
`;

const Subtitle = styled.p`
  ${({ theme }) => theme.fontSize.M14};
`;

function ModalHeader({
  image,
  imageAlt,
  title,
  subtitle,
  className,
}: ModalHeaderProps) {
  return (
    <Container className={className}>
      <Img src={image} alt={imageAlt} />
      <Title>{title}</Title>
      <Subtitle>{subtitle}</Subtitle>
    </Container>
  );
}

export { ModalHeader };
